/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Base pair creation request
 */
export interface BasePairCreationRequest {
  baseAssetId: number;
  quoteAssetId: number;
  qtyScale: number;
  priceScale: number;
  priceScaleView: number;
  isStableCoinPair: boolean;
  supportHouse: boolean;
  priceProtection: boolean;
}
